import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import CustomTooltip from './CustomTooltip';
import StopIcon from '@material-ui/icons/Stop';

const categories = [
  {name: 'NDIS Plan', color: '#21bfaf'},
  {name: 'Service Agreement', color: '#da3510'},
  {name: 'Intake Form', color: '#264f73'},
  {name: 'Medical Assessment', color: '#99f2bf'},
  {name: 'Invoice', color: '#f2a922'},
];

const catgoryBorderColor = category => {
  const items = categories.filter(c => c.name === category);
  if (items.length === 0) return {borderColor: '#d5d5d6'};
  return {borderColor: items[0].color};
};

const catgoryColor = category => {
  const items = categories.filter(c => c.name === category);
  if (items.length === 0) return {color: '#d5d5d6'};
  return {color: items[0].color};
};

const useStyles = makeStyles(() => ({
  chip: {
    borderRadius: '4px',
    width: '8rem',
    padding: '0.8rem 0.2rem',
    borderWidth: '3px',
    margin: 0,
  },
  label: {
    width: '8rem',
  },
}));

const DocumentCategoryChip = ({data, editable=false, setFileCategory=null}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const cleanCategory = data.category === 'default' ? 'None' : data.category;

  const openSelect = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeSelect = () => {
    setAnchorEl(null);
  };

  const setCategory = async (value) => {
    setFileCategory(data.uuid, value);
    setAnchorEl(null);
  };

  if (!editable) {
    return (
      <Chip
        label={cleanCategory}
        variant="outlined"
        className={classes.chip}
        style={catgoryBorderColor(cleanCategory)}
        disableRipple
        clickable={false}
      />
    );
  }

  return (
    <React.Fragment>
      <CustomTooltip
        arrow
        placement="bottom-end"
        title="Change category"
      >
        <Chip
          label={cleanCategory}
          variant="outlined"
          className={classes.chip}
          style={catgoryBorderColor(cleanCategory)}
          disableRipple
          onClick={openSelect}
          clickable={true}
        />
      </CustomTooltip>
      {editable ? (
        <Popover
          id="category-selector"
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={closeSelect}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <List className={classes.list}>
            {categories.map((c, i) => (
              <ListItem key={i} button disableRipple onClick={()=>setCategory(c.name)}>
                <StopIcon fontSize="large" style={catgoryColor(c.name)} />
                <Typography variant="body2" color="primary">{c.name}</Typography>
              </ListItem>
            ))}
          </List>
        </Popover>
      ) : null}
    </React.Fragment>
  );
};

DocumentCategoryChip.propTypes = {
  data: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  setFileCategory: PropTypes.func,
};

export default DocumentCategoryChip;
